import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, User, UserPlus, ArrowLeft, Check } from 'lucide-react';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    acceptTerms: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Gérer la soumission du formulaire ici
    console.log('Form submitted:', formData);
  };

  return (
    <div className="min-h-screen text-white pt-20 md:pt-32">
      {/* Background effects */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(1,125,126,0.15),transparent_50%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center_left,rgba(0,169,157,0.15),transparent_50%)]" />
      </div>

      <div className="container mx-auto px-4">
        <div className="max-w-md mx-auto">
          {/* En-tête */}
          <div className="mb-8 flex items-center justify-between">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-white/70 hover:text-white transition-colors group"
            >
              <ArrowLeft className="w-5 h-5 transform group-hover:-translate-x-1 transition-transform" />
              Retour
            </button>
            <button
              onClick={() => navigate('/login')}
              className="text-white/70 hover:text-white transition-colors"
            >
              Déjà inscrit ?
            </button>
          </div>

          {/* Carte principale */}
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
            {/* En-tête de la carte */}
            <div className="text-center mb-8">
              <h1 className="text-2xl font-bold mb-2">Créer un compte</h1>
              <p className="text-white/70">Commencez votre expérience avec nous</p>
            </div>

            {/* Formulaire */}
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Nom complet */}
              <div>
                <label className="block text-sm font-medium mb-2">Nom complet</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <User className="h-5 w-5 text-white/40" />
                  </div>
                  <input
                    type="text"
                    className="block w-full pl-10 pr-3 py-2.5 bg-white/5 border border-white/10 rounded-lg
                           focus:ring-2 focus:ring-green-500/40 focus:border-green-500/40
                           text-white placeholder-white/40 transition-colors
                           hover:border-white/20"
                    placeholder="John Doe"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                  />
                </div>
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Mail className="h-5 w-5 text-white/40" />
                  </div>
                  <input
                    type="email"
                    className="block w-full pl-10 pr-3 py-2.5 bg-white/5 border border-white/10 rounded-lg
                           focus:ring-2 focus:ring-green-500/40 focus:border-green-500/40
                           text-white placeholder-white/40 transition-colors
                           hover:border-white/20"
                    placeholder="votre@email.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                  />
                </div>
              </div>

              {/* Mot de passe */}
              <div>
                <label className="block text-sm font-medium mb-2">Mot de passe</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Lock className="h-5 w-5 text-white/40" />
                  </div>
                  <input
                    type="password"
                    className="block w-full pl-10 pr-3 py-2.5 bg-white/5 border border-white/10 rounded-lg
                           focus:ring-2 focus:ring-green-500/40 focus:border-green-500/40
                           text-white placeholder-white/40 transition-colors
                           hover:border-white/20"
                    placeholder="••••••••"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    required
                  />
                </div>
              </div>

              {/* Confirmer mot de passe */}
              <div>
                <label className="block text-sm font-medium mb-2">Confirmer le mot de passe</label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Check className="h-5 w-5 text-white/40" />
                  </div>
                  <input
                    type="password"
                    className="block w-full pl-10 pr-3 py-2.5 bg-white/5 border border-white/10 rounded-lg
                           focus:ring-2 focus:ring-green-500/40 focus:border-green-500/40 text-white placeholder-white/40 transition-colors
                           hover:border-white/20"
                    placeholder="••••••••"
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                    required
                  />
                </div>
              </div>

              {/* Conditions d'utilisation */}
              <div className="space-y-4">
                <label className="flex items-start gap-3">
                  <div className="flex items-center h-6">
                    <input
                      type="checkbox"
                      className="w-4 h-4 rounded border-white/10 bg-white/5 text-[#017D7E] 
                               focus:ring-green-500/40 focus:ring-offset-0"
                      checked={formData.acceptTerms}
                      onChange={(e) => setFormData({ ...formData, acceptTerms: e.target.checked })}
                      required
                    />
                  </div>
                  <div className="text-sm text-white/70">
                    En créant un compte, vous acceptez nos{' '}
                    <button
                      type="button"
                      onClick={() => navigate('/terms')}
                      className="text-[#017D7E] hover:text-[#00A99D] transition-colors"
                    >
                      Conditions d'utilisation
                    </button>
                    {' '}et notre{' '}
                    <button
                      type="button"
                      onClick={() => navigate('/privacy')}
                      className="text-[#017D7E] hover:text-[#00A99D] transition-colors"
                    >
                      Politique de confidentialité
                    </button>
                  </div>
                </label>
              </div>

              {/* Bouton de soumission */}
              <button
                type="submit"
                className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg
                        bg-gradient-to-r from-green-500 to-[#017D7E] text-white font-medium
                        hover:from-green-600 hover:to-emerald-600 transition-all
                        focus:ring-2 focus:ring-green-500/40"
              >
                <UserPlus className="w-5 h-5" />
                Créer un compte
              </button>
            </form>

            {/* Séparateur */}
            <div className="relative mt-8 mb-4">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-white/10"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-[#050A1C] text-white/40">Ou inscrivez-vous avec</span>
              </div>
            </div>

            {/* Boutons sociaux */}
            <div className="grid grid-cols-3 gap-3">
              <button
                type="button"
                className="flex justify-center items-center py-2.5 px-4 rounded-lg border border-white/10
                         bg-white/5 hover:bg-white/10 transition-colors"
              >
                <img
                  className="h-5 w-5"
                  src="https://www.svgrepo.com/show/475656/google-color.svg"
                  alt="google"
                />
              </button>
              <button
                type="button"
                className="flex justify-center items-center py-2.5 px-4 rounded-lg border border-white/10
                         bg-white/5 hover:bg-white/10 transition-colors"
              >
                <img
                  className="h-5 w-5"
                  src="https://www.svgrepo.com/show/475647/facebook-color.svg"
                  alt="facebook"
                />
              </button>
              <button
                type="button"
                className="flex justify-center items-center py-2.5 px-4 rounded-lg border border-white/10
                         bg-white/5 hover:bg-white/10 transition-colors"
              >
                <img
                  className="h-5 w-5"
                  src="https://www.svgrepo.com/show/475661/github-color.svg"
                  alt="github"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;